var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{staticClass:"theme--dark"},[_c('navbar'),_c('v-content',[_c('v-container',{attrs:{"fluid":"","fill-height":""}},[_c('v-layout',{attrs:{"justify-center":"","align-center":""}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }